import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index/index.vue'
import {getItem, saveItem} from '../utils/storage'
import {error} from '@/utils/message'
import {isWeiXin} from '@/utils/tools'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/home',
  //   name: 'home2',
  //   component: Index
  // },
  // {
  //   path: '/list',
  //   name: 'list',
  //   component: () => import('../views/list/list.vue')
  // },
  {
    path: '/',
    name: 'home',
    component: Index
  },
  {
    path: '/u/:phone',
    name: 'acting',
    component: Index
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/list/list.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/auth/register/register.vue')
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('../views/auth/reset/reset.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail/detail.vue')
  },
  {
    path: '/detailo',
    name: 'detailo',
    component: () => import('../views/detailo/detail.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order/order.vue')
  },
  {
    path: '/order/submit',
    name: 'order-submit',
    component: () => import('../views/order/submit/submit.vue')
  },
  {
    path: '/order/pay',
    name: 'pay',
    component: () => import('../views/order/pay/pay.vue')
  },
  {
    path: '/order/payline',
    name: 'payline',
    component: () => import('../views/order/payline/payline.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user/index/index.vue')
  },
  {
    path: '/userinfo',
    name: 'userinfo',
    component: () => import('../views/user/userinfo/userinfo.vue')
  },
  {
    path: '/user/order',
    name: 'user-order',
    component: () => import('../views/user/order/order.vue')
  },
  {
    path: '/user/order-detail',
    name: 'order-detail',
    component: () => import('../views/user/order-detail/order-detail.vue')
  },
  {
    path: '/user/address',
    name: 'user-address',
    component: () => import('../views/user/address/index/index.vue')
  },
  {
    path: '/user/address/edit',
    name: 'user-address-edit',
    component: () => import('../views/user/address/edit/edit.vue')
  },
  {
    path: '/user/safe',
    name: 'user-safe',
    component: () => import('../views/user/safe/safe.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('../views/cart/cart.vue')
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('../views/article/article.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/notice/index/index.vue')
  },
  {
    path: '/notice/detail',
    name: 'notice-detail',
    component: () => import('../views/notice/detail/detail.vue')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/message/index/index.vue')
  },
  {
    path: '/message/detail',
    name: 'message-detail',
    component: () => import('../views/message/detail/detail.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/news/index/index.vue')
  },
  {
    path: '/news/detail',
    name: 'news-detail',
    component: () => import('../views/news/detail/detail.vue')
  },
  {
    path: '/wechat/oauth',
    name: 'wechat-oauth',
    component: () => import('../views/wechat/oauth/oauth.vue')
  },
  {
    path: '/wechat/user',
    name: 'wechat-user',
    component: () => import('../views/wechat/user/user.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/test.vue')
  },
]



const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next)=>{
  let user = getItem('userinfo')
  if (!user) {
    let inRouterList = [
        'user-order',
        'user-address',
        'user-safe',
        'cart',
        'user-order',
        'user',
        'pay'
    ]
    let routerName = to.name
    let ret = inRouterList.find( (item) => {
        return item === routerName
    })
    if (ret) {
      if (isWeiXin()) {
        console.log('isWeiXin')
        saveItem('wx_backurl', encodeURIComponent(from.fullPath))
        next('/wechat/oauth?url=' + encodeURIComponent(from.fullPath))
      } else {
        error('您还没有登录，请先登录')
        next('/login')
      }
    } else {
      next()
    }
  }else{
    next()
  }
})

export default router
